























































import Vue, { VueConstructor } from 'vue';
import { mapGetters, mapState, mapMutations } from 'vuex';
import ForgetForm from '@/components/ForgetForm.vue';
import ActivateCustomerForm from '@/components/ActivateCustomerForm.vue';
import LocationSelector from '@/components/LocationSelector.vue';
import LoginForm from '@/components/LoginForm.vue';

interface VuexBindings {
	activateCustomer: boolean;
	hasLocation: boolean;
	isLoggedIn: boolean;
	location: Locations.Location;
}

export default (Vue as VueConstructor<Vue & VuexBindings>).extend({
	name: 'CustomerLogin',

	components: {
		ActivateCustomerForm,
		ForgetForm,
		LocationSelector,
		LoginForm,
	},

	data() {
		return {
			forget: false as boolean,
			forgotModel: {
				email: '',
				location: '',
			},
			loginModel: {
				location: '',
				login: '',
				password: '',
			},
		};
	},

	props: {
		idPrefix: String,
		hasMarketing: { type: Boolean, default: false },
		lockLocation: Boolean,
	},

	computed: {
		...mapState(['activateCustomer']),
		...mapState('location', ['locations']),
		...mapGetters(['isLoggedIn']),
		...mapGetters('location', ['hasLocation', 'location']),
	},

	methods: {
		...mapMutations(['setActivateCustomer']),
		getTitle() {
			if (this.activateCustomer) {
				return 'Activate Account';
			}

			if (this.forget) {
				return 'Forgot Password';
			}

			if (this.hasLocation && this.location && this.location.settings && this.location.settings.loyalty_name) {
				return `${this.location.settings.loyalty_name} Login`;
			}

			return 'Login';
		},

		onRequestedReset(response: any) {
			this.$emit('forgot', response);
		},

		onLogin(response: any) {
			this.$emit('login', response);
		},
		onActivate() {
			this.setActivateCustomer(true);
		},
	},
});
